import React, { useState, useEffect, useRef } from 'react'

const Report = () => {
	const mediaWeb = window.matchMedia("(min-width:600px)").matches
	const iframeRef = useRef(null);
	let width = window.innerWidth * (98.5 / 100);
	let tempHeight = window.innerHeight;
	let headerHeight = (9 / 100) * tempHeight;
	let height = tempHeight - headerHeight

	return (
		<>
			<iframe title="Agent Section" ref={iframeRef}
				width={width}
				height={tempHeight}
				src="https://chat-defis-flow.lovable.app/"
				frameborder="0"
				allowFullScreen="true"
			></iframe>
		</>
	)
}

export default Report